import React from 'react'
import {Box, Text, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {getUrl} from '../../../utils/cloudinary-utils'

const FontOptions = (props) => {
    const {
        showInitialSpinner,
        selectedFace,
        handleFaceSelect,
        setShowFonts,
        showFonts,
        setSelectedHeading,
        selectedFont,
        handleFontChange
    } = props
    return (
        <>
            <Box id="face-wrapper" gap="10px" display={showInitialSpinner ? 'none' : 'flex'}>
                {['face_1', 'face_2'].map((face) => (
                    <Box
                        key={face}
                        id={face}
                        data-selected-face-id={selectedFace}
                        border="0"
                        width="50%"
                        height="45px"
                        cursor="pointer"
                        padding="10px 18px"
                        fontSize="16px"
                        fontFamily="caslon"
                        className="hide-element"
                        borderRadius="3px"
                        color={selectedFace === face ? 'white' : 'black.100'}
                        fontWeight="500"
                        textAlign="center"
                        backgroundColor={selectedFace === face ? 'black.100' : 'gray.400'}
                        onClick={handleFaceSelect}
                    >
                        {face === 'face_1' ? 'Front' : 'Back'}
                    </Box>
                ))}
            </Box>
            <Box
                className="engraving-fonts-container"
                mt="20px"
                overflow="hidden"
                display={showInitialSpinner ? 'none' : 'block'}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    cursor="pointer"
                    onClick={() => {
                        setShowFonts(!showFonts)
                        setSelectedHeading('type')
                    }}
                    justifyContent="space-between"
                >
                    <Box gap="15px" display="inline-flex">
                        <Text color="black.100" fontSize="1rem" fontWeight="400">
                            <FormattedMessage id="engraving.font" defaultMessage="Font" />
                        </Text>
                        {selectedFont?.[selectedFace] && (
                            <Text color="black.100" fontSize="1rem" fontWeight="300">
                                {selectedFont?.[selectedFace]}
                            </Text>
                        )}
                    </Box>
                    <Box display="flex" alignItems="center" gap="10px" position="relative">
                        <Text
                            fontSize="13px"
                            fontWeight="300"
                            color="black.300"
                            lineHeight="22px"
                            position="absolute"
                            top="-4px"
                            textDecoration="underline"
                            textUnderlineOffset="4px"
                            right={!showFonts ? '25px' : '-127px'}
                            width="max-content"
                            transition="right 0.2s ease-out"
                        >
                            <FormattedMessage id="change.font" defaultMessage="Change Font" />
                        </Text>
                        <Image
                            width="15px"
                            height="15px"
                            alt="arrow"
                            transform={showFonts ? 'rotate(-90deg)' : 'rotate(90deg)'}
                            src={getUrl('UIImages/images/redesign/arrow-default.svg')}
                        />
                    </Box>
                </Box>
                <Box
                    className={`engraving-fonts ${showFonts ? 'show' : ''}`}
                    display="flex"
                    marginTop={showFonts ? '15px' : '0px'}
                    gap="10px"
                >
                    {['Clarendon', 'Futura', 'Vanessa', 'Monogram'].map((font) => (
                        <Box
                            key={font}
                            width="79px"
                            height="40px"
                            data-name={font}
                            cursor="pointer"
                            borderRadius="3px"
                            textAlign="center"
                            type="button"
                            backgroundColor={
                                selectedFont[selectedFace] === font ? 'gray.100' : 'white'
                            }
                            border="0.5px solid"
                            borderColor={selectedFont[selectedFace] === font ? 'black' : 'gray.400'}
                            onClick={handleFontChange}
                            data-font={font}
                            display="flex"
                            className="hide-element"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            {font === 'Clarendon' ? (
                                <Image
                                    alt="Clarendon"
                                    width="54px"
                                    margin="auto"
                                    height="25px"
                                    src={getUrl('UIImages/images/Engraving-Clarendon.svg')}
                                />
                            ) : (
                                <></>
                            )}
                            {font === 'Futura' ? (
                                <Image
                                    alt="Futura"
                                    margin="auto"
                                    width="43px"
                                    height="26px"
                                    src={getUrl('UIImages/images/Engraving-Futura.svg')}
                                />
                            ) : (
                                <></>
                            )}
                            {font === 'Vanessa' ? (
                                <Image
                                    alt="Vanessa"
                                    margin="auto"
                                    width="54px"
                                    height="26px"
                                    src={getUrl('UIImages/images/Engraving-Vanessa.svg')}
                                />
                            ) : (
                                <></>
                            )}
                            {font === 'Monogram' ? (
                                <Image
                                    alt="Monogram"
                                    margin="auto"
                                    src={getUrl('UIImages/images/Engraving-Monogram.svg')}
                                />
                            ) : (
                                <></>
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}

FontOptions.propTypes = {
    showInitialSpinner: PropTypes.bool,
    selectedFace: PropTypes.string,
    handleFaceSelect: PropTypes.func,
    setShowFonts: PropTypes.func,
    showFonts: PropTypes.bool,
    setSelectedHeading: PropTypes.func,
    selectedFont: PropTypes.string,
    handleFontChange: PropTypes.func
}

export default FontOptions
